import script from "./SetPurchase.vue?vue&type=script&setup=true&lang=js"
export * from "./SetPurchase.vue?vue&type=script&setup=true&lang=js"

export default script